export var Rarity;
(function (Rarity) {
    Rarity[Rarity["STAR"] = 0] = "STAR";
    Rarity[Rarity["FEATURE"] = 1] = "FEATURE";
    Rarity[Rarity["EPIC"] = 2] = "EPIC";
    Rarity[Rarity["LEGENDARY"] = 3] = "LEGENDARY";
    Rarity[Rarity["MYTHIC"] = 4] = "MYTHIC";
})(Rarity || (Rarity = {}));
